export const AFFILIATE_LOADING = "AFFILIATE_LOADING";
export const AFFILIATE_ERROR = "AFFILIATE_ERROR";
export const AFFILIATE_SUCCESS = "AFFILIATE_SUCCESS";
export const AFFILIATE_REFERRALS_SUCCESS = "AFFILIATE_REFERRALS_SUCCESS";
export const AFFILIATE_REFERRAL_USERS_SUCCESS = "AFFILIATE_REFERRAL_USERS_SUCCESS";